/**
 * @generated SignedSource<<2d52aad2f0c039c0128a0d9cf64dfd73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type GetPostByIdQuery$variables = {
  id: string;
};
export type GetPostByIdQuery$data = {
  readonly unified: {
    readonly ai: {
      readonly getPostById: {
        readonly __typename: "UnifiedAiPostResult";
        readonly __typename: "UnifiedAiPostResult";
        readonly post: {
          readonly author: {
            readonly aaid: string;
            readonly created_at: string;
            readonly email_id: string | null | undefined;
            readonly id: string;
            readonly nickname: string | null | undefined;
            readonly org_id: string | null | undefined;
            readonly updated_at: string;
          } | null | undefined;
          readonly author_id: string;
          readonly category: {
            readonly created_at: string;
            readonly description: string | null | undefined;
            readonly href: string;
            readonly id: string;
            readonly is_active: boolean;
            readonly name: string;
            readonly order: number;
            readonly parent_id: string | null | undefined;
            readonly type: string;
            readonly updated_at: string;
          } | null | undefined;
          readonly category_id: string;
          readonly content: string;
          readonly created_at: string;
          readonly edit_history: ReadonlyArray<{
            readonly edit_reason: string | null | undefined;
            readonly edited_at: string;
            readonly editor: {
              readonly aaid: string;
              readonly id: string;
              readonly nickname: string | null | undefined;
            } | null | undefined;
            readonly editor_id: string;
            readonly id: string;
            readonly post_id: string;
          } | null | undefined> | null | undefined;
          readonly id: string;
          readonly is_locked: boolean;
          readonly is_pinned: boolean;
          readonly like_ids: ReadonlyArray<string>;
          readonly responses: ReadonlyArray<{
            readonly author: {
              readonly aaid: string;
              readonly id: string;
              readonly nickname: string | null | undefined;
            } | null | undefined;
            readonly author_id: string;
            readonly content: string;
            readonly created_at: string;
            readonly edited_at: string | null | undefined;
            readonly id: string;
            readonly is_edited: boolean;
            readonly is_solution: boolean;
            readonly is_spam: boolean;
            readonly like_ids: ReadonlyArray<string>;
            readonly order: number;
            readonly parent_response: {
              readonly author_id: string;
              readonly content: string;
              readonly created_at: string;
              readonly id: string;
              readonly updated_at: string;
            } | null | undefined;
            readonly parent_responseid: string | null | undefined;
            readonly post_id: string;
            readonly responses: ReadonlyArray<{
              readonly author_id: string;
              readonly content: string;
              readonly created_at: string;
              readonly id: string;
              readonly updated_at: string;
            } | null | undefined> | null | undefined;
            readonly updated_at: string;
          } | null | undefined> | null | undefined;
          readonly tags: ReadonlyArray<string>;
          readonly title: string;
          readonly type: string;
          readonly updated_at: string;
        };
      } | {
        readonly __typename: "UnifiedQueryError";
        readonly code: string | null | undefined;
        readonly extensions: ReadonlyArray<{
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        }> | null | undefined;
        readonly identifier: string | null | undefined;
        readonly message: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type GetPostByIdQuery = {
  response: GetPostByIdQuery$data;
  variables: GetPostByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "author_id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "like_ids",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updated_at",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aaid",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nickname",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "post_id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "edited_at",
  "storageKey": null
},
v13 = [
  (v1/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v14 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v4/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedQuery",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedAiQuery",
        "kind": "LinkedField",
        "name": "ai",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
              }
            ],
            "concreteType": null,
            "kind": "LinkedField",
            "name": "getPostById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedAiPost",
                    "kind": "LinkedField",
                    "name": "post",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "category_id",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "is_pinned",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "is_locked",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tags",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAiAccount",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email_id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "org_id",
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAiCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "href",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parent_id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "is_active",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAiResponse",
                        "kind": "LinkedField",
                        "name": "responses",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          (v11/*: any*/),
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "is_solution",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "is_edited",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "is_spam",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "parent_responseid",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedAiAccount",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedAiResponse",
                            "kind": "LinkedField",
                            "name": "parent_response",
                            "plural": false,
                            "selections": (v14/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedAiResponse",
                            "kind": "LinkedField",
                            "name": "responses",
                            "plural": true,
                            "selections": (v14/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnifiedAiEditHistory",
                        "kind": "LinkedField",
                        "name": "edit_history",
                        "plural": true,
                        "selections": [
                          (v1/*: any*/),
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "editor_id",
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "edit_reason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnifiedAiAccount",
                            "kind": "LinkedField",
                            "name": "editor",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedAiPostResult",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "identifier",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedQueryErrorExtension",
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "UnifiedQueryError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetPostByIdQuery",
    "selections": (v15/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetPostByIdQuery",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "21a2d2aafd0fa4b6455c5c16d61672bc",
    "id": null,
    "metadata": {},
    "name": "GetPostByIdQuery",
    "operationKind": "query",
    "text": "query GetPostByIdQuery(\n  $id: String!\n) {\n  unified {\n    ai {\n      getPostById(id: $id) {\n        __typename\n        ... on UnifiedAiPostResult {\n          __typename\n          post {\n            id\n            title\n            content\n            type\n            category_id\n            author_id\n            is_pinned\n            is_locked\n            like_ids\n            created_at\n            updated_at\n            tags\n            author {\n              id\n              aaid\n              email_id\n              org_id\n              nickname\n              created_at\n              updated_at\n            }\n            category {\n              id\n              name\n              href\n              type\n              description\n              order\n              parent_id\n              is_active\n              created_at\n              updated_at\n            }\n            responses {\n              id\n              content\n              post_id\n              author_id\n              created_at\n              updated_at\n              edited_at\n              is_solution\n              is_edited\n              is_spam\n              like_ids\n              order\n              parent_responseid\n              author {\n                id\n                aaid\n                nickname\n              }\n              parent_response {\n                id\n                content\n                author_id\n                created_at\n                updated_at\n              }\n              responses {\n                id\n                content\n                author_id\n                created_at\n                updated_at\n              }\n            }\n            edit_history {\n              id\n              post_id\n              editor_id\n              edited_at\n              edit_reason\n              editor {\n                id\n                aaid\n                nickname\n              }\n            }\n          }\n        }\n        ... on UnifiedQueryError {\n          identifier\n          message\n          code\n          extensions {\n            statusCode\n            errorType\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b8d9c292c9ce55957cdc3895bee0924d";

export default node;
